import { Injectable } from '@angular/core';
import { global } from '../../shared/global';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class SuggestionService {

  constructor(private http : HttpClient) { }

  insertSuggestion(data)
  {
    return this.http.post(global.baseAPIUrl + "bom/newbom_api/netsol/addsuggestion.php", data);
  }
}
